// extracted by mini-css-extract-plugin
export default {"root":"tips-module___root___d1508adb","header":"tips-module___header___c41faa3b","copy":"tips-module___copy___c8725915","list":"tips-module___list___ab2de6fd"};